import {validateRegion,toRegionPoint,districtOrigin} from './region.mjs';
/** An overview of assigned metadata, not evidence that neighboring scenes are loaded. */
export function regionMapContext(input,world,player,participants=[]) {
  if(!input)return null;
  let region;try{region=validateRegion(input);}catch{return null;}
  const d=region.districts.find(d=>d.worldId===world.id);if(!d)return null;
  const origin=districtOrigin(region,d.id),width=region.columns*region.tileSize.x,depth=region.rows*region.tileSize.z,size=Math.max(width,depth);
  const b=world.bounds??{minX:-50,maxX:50,minZ:-50,maxZ:50};
  const bounds={minX:b.minX+origin.x,maxX:b.maxX+origin.x,minZ:b.minZ+origin.z,maxZ:b.maxZ+origin.z};
  const convert=position=>toRegionPoint(region,d.id,{x:position.x,y:position.y??0,z:position.z});
  const cells=[];
  for(let row=0;row<region.rows;row++)for(let column=0;column<region.columns;column++){
    const assignment=region.districts.find(d=>d.column===column&&d.row===row);
    cells.push({column,row,id:assignment?.id??null,minX:(column-region.columns/2)*region.tileSize.x,minZ:(row-region.rows/2)*region.tileSize.z,width:region.tileSize.x,depth:region.tileSize.z});
  }
  return {region,district:d,cells,origin,frame:{minX:-size/2,minZ:-size/2,size,bounds},
    world:{...world,bounds,portals:(world.portals??[]).map(p=>({...p,position:convert(p.position)}))},
    player:{...player,position:convert(player.position)},participants:participants.filter(p=>p?.worldId===world.id&&Number.isFinite(p.position?.x)&&Number.isFinite(p.position?.z)).map(p=>({...p,position:convert(p.position)}))};
}
